import { isVueAppInDOM, renderApp } from '@/src/shared/component-utilities';

import PaymentMethodList from './PaymentMethodList.vue';

export function load() {
  const selector = 'zel-payment-method-list';

  if (!isVueAppInDOM(selector)) {
    return;
  }

  renderApp(PaymentMethodList, selector);
}
